import * as R from "ramda";

const root = R.lensProp("refunds-report");
const data = R.compose(root, R.lensProp("data"));
const error = R.compose(root, R.lensProp("error"));
const loading = R.compose(root, R.lensProp("isLoading"));
const csvUrl = R.compose(root, R.lensProp("csvUrl"));

export default Object.assign(root, {
  data,
  error,
  loading,
  csvUrl,
});
